import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetUserIdByEmail($email: String!, $tenantId: String!) {
    getUserByEmail(email: $email, tenantId: $tenantId) {
      uuid
    }
  }
`

export const getUserByEmailKey = getQueryNames(query)[0]

export default query
